import assetTags from './asset-tags.json';
import assetDetails from './assets/asset-details.json';
import assetInstances from './assets/asset-instances.json';
import assetLayout from './assets/asset-layout.json';
import assetList from './assets/asset-list.json';
import assetProfile from './assets/asset-profile.json';
import assetRelatedScans from './assets/asset-related-scans.json';
import assetsTable from './assets/assets-table.json';
import category from './assets/category.json';
import fields from './assets/fields.json';
import importance from './assets/importance.json';
import source from './assets/source.json';

const en = {
  assetDetails,
  assetInstances,
  assetLayout,
  assetList,
  assetProfile,
  assetRelatedScans,
  tagManagement: 'Tag Management',
  assetTagManagement: 'Asset Tag Management',
  assetTags,
  assetsTable,
  category,
  fields,
  importance,
  assets: 'Assets',
  myAssets: 'My Assets',
  source,
};

export default en;
